export default __webpack_public_path__ + "assets/659a2654b03078dd75add4aae62081c4.jpeg";